import React, { ReactNode } from 'react';
import { Form, Header, Icon, Segment } from 'semantic-ui-react';
import './styles.css';

function Legend() {
    return (
        <Segment>
            <Header as={'h3'}>Legend</Header>
            <Section>
                <Icon name="info" color="red" />
                <p>
                    - Fuzzy Diff between the data in the Latest and Original versions or between reported and
                    Period-To-Period calculated data. NOTE: This icon has the priority over the rest. This means that
                    the data marked with such icon can also be also reported with different label, calculated by 3D, or
                    Period-To-Period Calculated.
                </p>
            </Section>
            <Section>
                <Icon color="yellow" name="info" />
                <p>- Period-To-Period calculated data.</p>
            </Section>
            <Section>
                <Icon color="grey" name="info" />
                <p>
                    - The data is not presented directly in the financial statement but is vertically calculated by 3D
                    based on other reported data.
                </p>
            </Section>
            <Section>
                <Icon color="blue" name="info" />
                <p>
                    - The data is reported with label different than the general label of the row in the table or there
                    is a specific "Note" related to data.
                </p>
            </Section>
            <Section>
                <Icon color="green" name="info" />
                <p>- Field Source is present</p>
            </Section>
            <Header as={'h4'}>Read mode view</Header>
            <Section>
                <Table valueCellClasses="view-cell invalidCellValue-INVALID" />
                <div>
                    <p>- This means one of the following:</p>
                    <ul>
                        <li>
                            The <b>Core Data</b> is presented and not <b>Manually Calculated</b> but the{' '}
                            <b>Reported as Label</b> is missing.
                        </li>
                        <li>
                            The data is marked as <b>Manually Calculated</b> but the <b>Reported As Label</b> is
                            presented.
                        </li>
                    </ul>
                </div>
            </Section>
            <Section>
                <Table valueCellClasses="view-cell invalidCellValue-WARN" valueCellContent="" />
                <p>
                    - The <b>Reported As Label</b> is presented but the Core Value is missing.
                </p>
            </Section>
            <Section>
                <Table valueCellClasses="bg-light-blue" valueCellContent={<DisabledAutomaticCalculationEmpty />} />
                <p>
                    - The <b>Automatic Calculation</b> has been disabled and the Core Value is set to empty
                </p>
            </Section>
            <Section>
                <Table valueCellClasses="bg-light-blue" valueCellContent={<DisabledAutomaticCalculation />} />
                <p>
                    - The<b> Automatic Calculation</b> has been disabled
                </p>
            </Section>
            <Section>
                <Table valueCellClasses="bg-light-blue" valueCellContent={<ManuallyCalculatedEmpty />} />
                <p>
                    - The <b>Core Value</b> is manually calculated and set to empty
                </p>
            </Section>
            <Section>
                <Table valueCellClasses="bg-light-blue" valueCellContent={<ManuallyCalculated />} />
                <p>
                    - The <b>Core Value</b> is manually calculated
                </p>
            </Section>
            <Section>
                <Table valueCellClasses="bg-light-blue" valueCellContent={<ExtendedSearch />} />
                <p>
                    - Field has not been found even after <b>Extended Search</b>
                </p>
            </Section>
            <Header as={'h4'}>Edit mode view</Header>
            <Section>
                <div className="editColumn">
                    <Form.Field className={`reportedAsLabel editLabel invalidCellValue-INVALID`} disabled={true}>
                        <input
                            value={''}
                            type="text"
                            placeholder="Reported as Label"
                            disabled={true}
                            className="reportedAsLabel editLabel"
                        />
                    </Form.Field>
                    <Form.Field className="bg-light-blue" disabled={true}>
                        <input type="text" value={123} disabled={true} />
                    </Form.Field>
                </div>
                <p>
                    - The <b>Reported As Label</b> is missing while the <b>Core Value</b> for the field has been
                    provided.
                </p>
            </Section>
            <Section>
                <div className="editColumn">
                    <Form.Field className={`reportedAsLabel editLabel invalidCellValue-WARN`} disabled={true}>
                        <input
                            value={'Revenue'}
                            type="text"
                            placeholder="Reported as Label"
                            disabled={true}
                            className="reportedAsLabel editLabel"
                        />
                    </Form.Field>
                    <Form.Field className="bg-light-blue" disabled={true}>
                        <input type="text" value={''} placeholder="value" disabled={true} />
                    </Form.Field>
                </div>
                <p>
                    - The <b>Reported As Label</b> was provided but the <b>Core Value</b> is missing
                </p>
            </Section>
            <Section>
                <div className="editColumn">
                    <Form.Field className={`reportedAsLabel editLabel invalidCellValue-INVALID`} disabled={true}>
                        <input
                            value={'Revenue'}
                            type="text"
                            placeholder="Reported as Label"
                            disabled={true}
                            className="reportedAsLabel editLabel"
                        />
                    </Form.Field>
                    <Form.Field className="bg-light-blue" disabled={true}>
                        <input type="text" value={123} disabled={true} />
                    </Form.Field>
                </div>
                <p>
                    - The <b>Reported As Label</b> was provided but the field is marked as <b>Manually Calculated</b>
                </p>
            </Section>
        </Segment>
    );
}

function Section({ children }: { children: ReactNode }) {
    return <div className="legend__section">{children}</div>;
}

type TablePropsType = {
    valueCellClasses: string;
    valueCellContent?: ReactNode;
};

function Table({ valueCellClasses, valueCellContent = '123' }: TablePropsType) {
    return (
        <table className="legend__table">
            <tbody>
                <tr>
                    <td className="bg-light-blue">Field Name</td>
                    <td className={`legend__table__value-cell ${valueCellClasses}`}>{valueCellContent}</td>
                </tr>
            </tbody>
        </table>
    );
}

function DisabledAutomaticCalculationEmpty() {
    return <div className="disabled-automatic-calculation-empty"></div>;
}

function DisabledAutomaticCalculation() {
    return <div className="disabled-automatic-calculation">123</div>;
}

function ManuallyCalculatedEmpty() {
    return <div className="manually-calculated-empty"></div>;
}

function ManuallyCalculated() {
    return <div className="manually-calculated">123</div>;
}

function ExtendedSearch() {
    return <div className="extended-search"></div>;
}

export default Legend;
